import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, FormGroup, Input, Row,Col } from 'reactstrap'
import save from "assets/icon/save.svg";
import useAxios from 'hooks/useAxios';
import ReactStrapTable from 'components/reactStrapTable';
import { cellRendererCheck } from 'utils/columns';
import Loader from 'components/Loader';


let checkedIds = [];
let hasFlagY = false;
const HL7Drawer = (props) => {
    const {toggleopenDrawer,SelectedAccumulator,orgId,hyperLinkFlag,setyperLinkFlag} = props;
const API = useAxios();
const [data,setData] = useState([]);
const [selectedIds, setSelectedIds] = useState([]);
const[loading,setLoading] = useState(false)
 
debugger;
useEffect(()=>{
  if(hyperLinkFlag){
    hasFlagY= false;
    handlehyperLinDetails()
  }
  else{
    hasFlagY= false;
    handleHL7message();
  }
},[])

    const handleHL7message = async () => {
      debugger;
      setLoading(true)
      try {
        const { data } = await API.get(`SBConfig/TypeStatus/hl7Messages/${SelectedAccumulator}`,{ hasDefaultURL: true });
  
        if (data) {
         hasFlagY = data.some(c => c.flag === 'Y');
          if(hasFlagY){
            handlehyperLinDetails();
            setyperLinkFlag(true);
          }
          else{
            setData(data)
            setLoading(false)
          }
    
          
        } else {
          setLoading(false)
         
        }
      } catch (err) { 
        setLoading(false)
      }
    };
    const handlehyperLinDetails = async () => {
      debugger;
  setLoading(true)
      try {
      
        const { data } = await API.get(
          `SBTenant/${orgId.tenantID}/Configuration/hyperLinkHl7Messages/${SelectedAccumulator}/${true}`,
          {
            hasDefaultURL: true,
          }
        );
        if (data) {
          setData(data);
          setLoading(false)
          
        }
        setLoading(false);
      } catch (error) {
        setLoading(false)
      }
    };
    const handleAdd = ()=>{
      handleADDHL7message();
    }
    const handleADDHL7message = async () => {
      let payload = {};
      debugger;
      payload.Hl7Codes = checkedIds;
      setLoading(false);
      try {
        const { data } = await API.post(
          `SBTenant/${orgId.tenantID}/Configuration/addHl7Messages/${SelectedAccumulator}/${"PatientLocation"}`,payload,
          {
            hasDefaultURL: true,
          }
        );
  
        if (data) {
          setLoading(false)
          toggleopenDrawer();
        } else {
          setLoading(false)
        }
      } catch (err) { 
        setLoading(false)
      }
    };
    let colomns = [
    {
      text: 'Select',
      cellRenderer: (rowData) => renderCheckbox(rowData),
      width: 20,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true
  },
  {
      dataField: 'code',
      text: 'Message /Event Type',
      width: 80,
      show: true,
      sort: false,
      inputType: 'text',
      cellRenderer: (row) => cellRendererCheck(row.code)
  },
  {
    dataField: 'description',
    text: 'Description',
    width: 130,
    show: true,
    sort: false,
    inputType: 'text',
    cellRenderer: (row) => cellRendererCheck(row.description)
},
]
const renderCheckbox = (claim) => {
 
  const filter = selectedIds.filter((item) => item === claim.code);
  return (
      <Input
          onChange={() => onChange(claim)}
          type='checkbox'
          className='me-2 mt-0'
          value={filter.length > 0}
          checked={(hyperLinkFlag || (claim.flag == "Y"  && claim.code))? true :filter.length > 0}
          disabled={hyperLinkFlag || claim.flag == "Y" }
      />);
}
const onChange = (claim) => {
 
  const { code } = claim;
  const index = checkedIds.indexOf(code);
  if (checkedIds.length === 0) {
      checkedIds.push(code);
  } else {
      if (index >= 0) {
          checkedIds.splice(index, 1);

      } else {
          checkedIds.push(code);
      }
  }
  setSelectedIds([...checkedIds]);
};

  return (
    <div className="table-card scroll-table position-relative border-0 rounded pt-0"
    fixed-height={data?.length > 0 ? 'fixed-height' : 'default'}>
      {loading && <Loader opacity={0.01} color='black' />}
      <ReactStrapTable 
  
      data={data}
      columns={colomns}
      />
      <Row >
      <Col md={10}>
      <p  hidden={hyperLinkFlag} style={{fontSize:11}}><strong>Note : </strong>User need to click the 'SAVE' button on the configuration screen in order to make system capture the selceted messsage event types </p>
      <p hidden={hasFlagY== false}  style={{fontSize:11}}><strong>Note : </strong>To make configuration changes for Message Event type selection please rise a support ticket to support@thepharmaforce.com. </p>

      </Col>
      <Col md={2}>
      <Button
        disabled={checkedIds.length == 0}
        hidden={hyperLinkFlag}
        style={{float:'right'}}
        

          color="primary"
          className="search"
          onClick={handleAdd}

        >
          <span className="right_5">
            {" "}
            <img src={save} alt="" />
          </span>{" "}
          save
        </Button>
      </Col>
      
        
      </Row>
    </div>
  
  )
}

export default HL7Drawer